import { useMemo } from 'react'
import useAxios from 'axios-hooks'

const namespace = 'scholarships-stage'

export const useCount = (params) => {
  const [
    {
      data: stagedCount,
      loading: stagedCountLoading,
      error: stagedCountError,
    },
    getStagedCount,
  ] = useAxios({ url: `${namespace}/count`, params })

  return useMemo(() => ({
    stagedCount,
    stagedCountLoading,
    stagedCountError,
    getStagedCount,
  }), [
    stagedCountLoading,
    stagedCountError,
    getStagedCount,
  ])
}
